import React from 'react'

/**
 * StatusBanner — informational banner shown below the canvas header.
 * Appears for non-draft statuses only.
 *
 * Props:
 *   status  string  — session status
 */
export function StatusBanner({ status }) {
  if (status === 'draft') return null

  const config = {
    ready: {
      tone: 'info',
      text: 'Prep is marked ready and locked for editing. The session will unlock once it starts.',
    },
    'in-session': {
      tone: 'success',
      text: 'Session is in progress.',
    },
    completed: {
      tone: 'success',
      text: 'Session completed. All sections are locked.',
    },
    cancelled: {
      tone: 'neutral',
      text: 'Session was cancelled. All sections are locked.',
    },
  }

  const entry = config[status]
  if (!entry) return null

  return (
    <div
      className={`banner banner--${entry.tone}`}
      role="status"
      aria-live="polite"
      data-testid="status-banner"
    >
      {entry.text}
    </div>
  )
}
